import { BaseResource } from 'e100-data-providers';
import { RestProvider } from 'dataSources/types/restProvider';
import { EMPTY_STRING } from 'common/constants';

import {
  Report,
  CreateReportForm,
  ReportGuid,
  ComparePricesReportForm,
} from './types';

export class ReportsApi extends BaseResource {
  path: string = EMPTY_STRING;

  constructor(provider: RestProvider) {
    super(provider);
    this.path = 'reports';
  }

  createReport(form: CreateReportForm): Promise<{ reportGuid: ReportGuid }> {
    return this.send(
      this.getChildResource('uiStationList').request.post().setBody(form),
    );
  }

  getReports(): Promise<{ reports: Report[] }> {
    return this.getChildResource('list').getItems();
  }

  getReport(reportGuid: ReportGuid): Blob {
    return this.send(
      this.getChildResource(`download/${reportGuid}`)
        .request.get()
        .setOptions({ isBinary: true }),
    );
  }

  createComparePricesOnRouteReport(
    form: ComparePricesReportForm,
  ): Promise<{ reportGuid: ReportGuid }> {
    return this.send(
      this.getChildResource('route-compare-prices')
        .request.post()
        .setBody(form),
    );
  }

  createComparePricesReport(
    form: ComparePricesReportForm,
  ): Promise<{ reportGuid: ReportGuid }> {
    return this.send(
      this.getChildResource('uiStationList/compare-prices')
        .request.post()
        .setBody(form),
    );
  }

  createUnauthReport(
    form: Omit<CreateReportForm, 'withPrices' | 'withVat' | 'serviceNts'>,
  ): Promise<{ reportGuid: ReportGuid }> {
    return this.send(
      this.getChildResource('unauthorized/uiStationList')
        .request.post()
        .setBody(form),
    );
  }

  getUnauthReportStatus(
    reportGuid: ReportGuid,
  ): Promise<{ reportState: Report['state'] }> {
    return this.send(
      this.getChildResource(`unauthorized/status/${reportGuid}`).request.get(),
    );
  }

  getUnauthReport(reportGuid: ReportGuid): Blob {
    return this.send(
      this.getChildResource(`unauthorized/download/${reportGuid}`)
        .request.get()
        .setOptions({ isBinary: true }),
    );
  }
}
